import { SponsorDirectory } from '@/components/organizations/SponsorDirectory';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(SponsorDirectory, {
  requiresEvery: [RouteRestrictions.SPONSOR_DIRECTORY_ACCESS],
});
